import axios from 'axios';

const serverWithToken = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': "application/json" },
    withCredentials: true
});


const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': "application/json" },
});



export class ClientsFetchAPI {

    static async getCurrentClient(token, client_id, options = {}) {
        if (!client_id) throw new Error("No hay un cliente autenticado");

        const res = await serverWithToken(`/client/${encodeURIComponent(client_id)}`, {
            method: "get",
            headers: token ? { 'x-access-token': token } : undefined,
            skipOwnershipErrorHandler: options.skipOwnershipErrorHandler,
        });
        return res
    }

    static async updateCurrentClient(data, token, client_id ) {
        if (!client_id) throw new Error("No hay un cliente autenticado");

        const res = await serverWithToken(`/client/${encodeURIComponent(client_id)}`, {
            method: "put",
            data: data,
            headers: token ? { 'x-access-token': token } : undefined,
        });
        return res
    }

    static async getClientType(token) {
        const res = await serverWithToken(`/clients_types`, {
            method: "get",
            headers: token ? { 'x-access-token': token } : undefined,
        });
        return res
    }

    static async getClientsByBusiness(business_id, token, options = {}) {
        const res = await serverWithToken(`/client/${business_id}/business_clients`, {
            method: "get",
            headers: token ? { 'x-access-token': token } : undefined,
            skipOwnershipErrorHandler: options.skipOwnershipErrorHandler,
        });
        return res
    }

    static async getClientsById(client_id, token, options = {}) {
        const res = await serverWithToken(`/client/${client_id}`, {
            method: "get",
            headers: token ? { 'x-access-token': token } : undefined,
            skipOwnershipErrorHandler: options.skipOwnershipErrorHandler,
        });
        return res
    }

    static async createClient(data, token, options = {}) {
        const res = await serverWithToken(`/client`, {
            method: "post",
            data: data,
            headers: token ? { 'x-access-token': token } : undefined,
            skipOwnershipErrorHandler: options.skipOwnershipErrorHandler,
        });
        return res
    }

    static async updateClient(data, client_id, token) {
        const res = await serverWithToken(`/client/${client_id}`, {
            method: "put",
            data: data,
            headers: token ? { 'x-access-token': token } : undefined,
        });
        return res
    }

    static async requestPasswordRecovery(data) {
        const res = await serverWithToken(`/client/password-recovery/request`, {
            method: "post",
            data: data,
        });
        return res
    }

    static async verifyPasswordRecovery(data) {
        const res = await serverWithToken(`/client/password-recovery/verify`, {
            method: "post",
            data: data,
        });
        return res
    }

    static async resetPasswordRecovery(data, token) {
        const res = await serverWithToken(`/client/password-recovery/reset`, {
            method: "post",
            data: data,
            headers: token ? { 'x-access-token': token } : undefined,
        });
        return res
    }

    static async registerVerification(data, token, recovery_pass) {

        let url = "/verify-client"
        if (recovery_pass === undefined) {
            url = `/verify-client`
        } else {
            url = `/verify-client?recovery_pass=${recovery_pass}`
        }
        const res = await serverWithToken(url, {
            method: "post",
            data: data,
            headers: token ? { 'x-access-token': token } : undefined,
        });
        return res
    }

    static async loginClientForBusiness(data, token) {
        const res = await serverWithToken(`/auth/loginclient`, {
            method: "post",
            data: data,
            headers: token ? { 'x-access-token': token } : undefined,
        });
        return res
    }

    static async getFrecuentShopperPointsTransactions(client_id, token) {
        const url = client_id ? `/frequent-shopper/client/${client_id}` : `/frequent-shopper/client/me`;
        const res = await serverWithToken(url, {
            method: "get",
            headers: token ? { 'x-access-token': token } : undefined,
        });
        return res
    }

    static async manageFrequentShopperPoints(client_id, data, token) {
        const res = await serverWithToken(`/frequent-shopper/client/${client_id}`, {
            method: "post",
            data: data,
            headers: token ? { 'x-access-token': token } : undefined,
        });
        return res
    }

    static async createAddressClient(data, token) {
        const payload = { ...(data || {}) };

        const res = await serverWithToken(`/direction/client`, {
            method: "post",
            data: payload,
            headers: token ? { 'x-access-token': token } : undefined,
        });
        return res
    }

    static async getAddressClient(client_id, token) {
        const url = client_id ? `/direction/client?client_id=${client_id}` : `/direction/client`;
        const res = await serverWithToken(url, {
            method: "get",
            headers: token ? { 'x-access-token': token } : undefined,
        });
        return res
    }

    static async deleteAddressClient(direction_id, token) {
        const res = await serverWithToken(`/direction/client?direction_id=${direction_id}`, {
            method: "delete",
            headers: token ? { 'x-access-token': token } : undefined,
        });
        return res
    }

    static async updateAddressClient(direction_id, data, token) {
        const res = await serverWithToken(`/direction/client?direction_id=${direction_id}`, {
            method: "put",
            data: data,
            headers: token ? { 'x-access-token': token } : undefined,
        });
        return res
    }
}
